<template>
  <span style="cursor: help">
    <i class="fal fa-question-circle fa-fw" />
  </span>
</template>
